import type { FC } from 'react';
import type { BlinkTraffic } from '../blinkTraffic';
import { BlinkPanel } from './BlinkPanel';

export type DeviceType = 'mobile' | 'tablet' | 'desktop';

export type AppProps = {
    blinkTraffic?: BlinkTraffic;
    deviceType: DeviceType;
};

export const App: FC<AppProps> = ({ deviceType, blinkTraffic }) => {
    return <BlinkPanel deviceType={deviceType} blinkTraffic={blinkTraffic} />;
};
